export function StatCard({ icon: Icon, label, value, hint, trend }) {
  return (
    <div className="ops-stat-card">
      <div className="ops-stat-card-icon">
        <Icon size={20} strokeWidth={1.8} />
      </div>
      <div className="ops-stat-card-content">
        <p className="ops-stat-card-label">{label}</p>
        <p className="ops-stat-value">{value}</p>
        {hint && <p className="ops-stat-hint">{hint}</p>}
      </div>
      {trend && (
        <span className={`ops-stat-trend ops-stat-trend--${trend.tone || "up"}`}>
          {trend.label}
        </span>
      )}
    </div>
  );
}
